import React from 'react';
import { ThemeProvider } from 'emotion-theming';
import { createBreakpointHelpers } from '@jetshop/ui/utils/breakpoints';
export const labels = ['xs', 'sm', 'md', 'lg'];
const breakpoints = ['20rem', '40rem', '50rem', '64rem'];
const { breakpointMap, above, below, between, only } = createBreakpointHelpers(labels, breakpoints);
const fontSizes = [
    '12px',
    '14px',
    '16px',
    '20px',
    '24px',
    '32px',
    '48px',
    '64px',
    '72px'
];
const space = [
    '0px',
    '8px',
    '16px',
    '24px',
    '32px',
    '40px',
    '48px',
    '56px',
    '64px'
];
const fontWeights = {
    light: 300,
    regular: 400,
    semibold: 700
};
const colors = {
    white: '#FFFFFF',
    black: '#000000',
    grey: '#878787',
    lightgrey: '#E8E8E8',
    tablegrey: '#F3F3F3',
    beige: '#f5f5dc',
    loadingBar: '#2f80ed',
    highlight: '#2F80ED'
};
export const baseTheme = {
    labels,
    breakpoints,
    breakpointMap,
    above,
    below,
    between,
    only,
    fontSizes,
    space,
    fontWeights,
    colors
};
const BaseThemeProvider = ({ children }) => {
    return React.createElement(ThemeProvider, { theme: baseTheme }, children);
};
export default BaseThemeProvider;
//# sourceMappingURL=Theme.js.map